module.exports = __webpack_public_path__ + "img/on_switch_2.ab48d1a0.svg";